module.exports = __webpack_public_path__ + "static/img/u16.d5e44e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u16.png
// module id = XBVd
// module chunks = 19